export enum uiPaths {
	ROOT = 'Profile',
	UNAUTHORIZED = 'Unauthorized',
	CUSTOMER_HOME = 'Home',
	PHOTO_IDENTIFICATION_CARD_APPLICATION = 'PhotoIdentificationCardApplication',
	PRODUCTS_PHOTO_ID = 'Products/PhotoIdentification',
	PRODUCTS_AUTOPAY_VEHICLE_REGISTRATION_RENEWAL = 'Products/AutoPayVehicleRegistrationRenewal',
	PRODUCTS_VEHICLE_REGISTRATION_CANCELLATION = 'Products/VehicleRegistrationCancellation',
	VERIFICATION_DOCUMENTS = 'DocumentWizard',
	PRODUCTS_STANDARD_VEHICLE_REGISTRATION_RENEWAL = 'Products/StandardVehicleRegistrationRenewal',
	PRODUCTS_STANDARD_CHANGE_VEHICLE_REGISTRATION = 'Products/StandardChangeVehicleRegistration',
	CUSTOMER_PAYMENT = 'Payment',
	VEHICLE_DETAIL = 'Vehicle/Detail',
	VEHICLES = 'Vehicles',
	SUPPORT = 'Support',
	COVERAGE = 'Coverage',
	CUSTOMER_CLAIMS = 'CustomerClaims',
  AF_CUSTOMER_CLAIMS= 'SelectPolicy',
	POLICIES = 'policies', // Deloitte route
	CLAIMS = 'claims', // Deloitte route
  CLAIMS_SELECT_POLICY = 'select-policy', // Deloitte route
	LICENCE = 'Licence',
	CUSTOMER_PROFILE = 'CustomerProfile',
	NOTIFICATION_CENTER = 'Notifications',
	CONTACT_US = 'ContactUs',
	ISSUERS = 'Issuers',
	PLATFORM_SELECT = 'PlatformSelect'
}

export enum bffEndpoints {
  SUBMIT_AUTOPAY_VEHICLE_REGISTRATION_RENEWAL = 'SubmitAutoPayRenewal',
  SUBMIT_STANDARD_VEHICLE_REGISTRATION_RENEWAL = 'SubmitStandardRenewal',
  SUBMIT_STANDARD_VEHICLE_REGISTRATION_RENEWAL_PAYMENT = 'SubmitPayment',
  GET_FEATURE_FLAG_STATUS = '/featureflags',
  GET_AUTHORIZED_FEATURE_FLAG_STATUS = '/featureflags/authorized',
  GET_CUSTOMER_PERSONAL_INFO = '/customers/GetPersonalInfo',
  GET_CUSTOMER_AUTH_CLAIMS = '/customers/GetCustomerAuthClaims',
  CUSTOMER_CLAIMS_VALIDATE_PLATE = '/claims/ValidatePlate',
  GET_CUSTOMER_INFO = '/customers/GetCustomerInfo',
  SEARCH_LICENCE_ISSUERS = '/customers/SearchLicenceIssuer',
  GET_AUTOPAY_RENEWAL_SAVED_ELIGIBILITY_QUESTIONS = '/customers/GetSavedEligibilityQuestions',
  GET_PAYMENT_METHODS = 'PaymentMethods',
  REQUEST_VEHICLE_POLICY_QUOTE = 'RequestVehiclePolicyQuote',
  GET_CUSTOMER_HEALTH = '/customers/GetHealthCheck',
  GET_CUSTOMER_FIN_HEALTH = '/customers/GetCustomerHealthCheck',
  REQUEST_CANCELLATION_SETTLEMENT = 'RequestCancellationSettlement',
  SUBMIT_VEHICLE_REGISTRATION_CANCELLATION = 'SubmitCancellation',
  UPDATE_VEHICLE_REGISTRATION_INFO = 'UpdateVehicleRegistrationInfo',
  GET_VEHICLE_REGISTRATION_RERATING_INFO = 'GetVehicleRegistrationReratingInfo',
  GET_ALL_REGISTRATIONS = 'GetAllRegistrations',
  GET_CLAIMS = 'GetClaims',
  GET_NOTIFICATIONS = '/customers/GetNotifications',
  GET_NEAREST_AUTOSHOP = '/customers/GetNearestAutoShop',
  GET_POLICIES = 'GetPolicies',
  GET_GIS_POLICIES = 'GetCustomerGISPolicies',
  GET_BROKER_DETAILS = 'GetBrokerDetails',
  GET_ISSUERS = '/Providers/Issuers',
  GET_LICENCE_ISSUERS = '/Providers/Issuers/SearchLicenceIssuer',
  GET_BROKERS = '/Providers/Brokers',
  GET_CUSTOMER_BY_CUSTOMERNUMBER = '/customers',
  GET_CONSOLIDATED_CUSTOMER = '/customers/GetConsolidatedCustomer',
  GET_ACTIVE_NOTIFICATIONS = '/notifications/getactive',
  MARK_NOTIFICATION_AS_READ = '/notifications/read',
  MARK_ALL_NOTIFICATIONS_AS_READ = '/notifications/readall',
  MARK_NOTIFICATIONS_AS_DISMISS = '/notifications/dismiss',
  SELECT_PREFERRED_ISSUER = 'SelectPreferredIssuer',
  SELECT_PREFERRED_METHOD_OF_COMMUNICATION = 'SelectPreferredMethodOfCommunication',
  GET_SERVER_DATETIME = '/customers/GetCurrentTime',
  GET_DMS_LOCATIONS_BY_PRODUCER_CODES = '/DmsLocations/GetByProducerCodes',
  GET_DMS_LOCATION_BY_ISSUER_CODE = '/DmsLocations/GetByIssuerCode',
  GET_GOOGLE_API_KEY = '/customers/GetGoogleAPIKey',
  GET_ALL_ISSUERS = '/DmsLocations/GetAllIssuers',
  GET_ISSUERS_BY_DISTANCE = '/DmsLocations/GetIssuersByDistance',
  GET_DMS_LOCATIONS_BANNER_BY_AGENCY_ID = '/DmsLocations/GetDmsLocationBannerUrlByAgencyId',
}

export enum bffControllers {
  VEHICLE_REGISTRATIONS = '/VehicleRegistrations',
  CLAIMS = '/Claims',
  POLICIES = '/Policies',
  CUSTOMERS = '/Customers',
  PARTNERS = '/Partners',
}

export enum externalLinks {
  FIND_BROKER = 'https://sgicanada.ca/findbroker',
}